export const SITE_URL =
    process.env.REACT_APP_SITE_URL?.replace(/\/$/, "") || "https://www.accruewise.in";

export const SITE_NAME = "Accruewise";

// 1200x630 share card (public/og-image.png); the square logo stays the organisation logo.
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;
export const SITE_LOGO = `${SITE_URL}/logo.webp`;

export const ORGANIZATION = {
    name: "ACCRUEWISE TECHNOLOGIES PRIVATE LIMITED",
    legalName: "ACCRUEWISE TECHNOLOGIES PRIVATE LIMITED",
    url: SITE_URL,
    logo: SITE_LOGO,
    email: "care@accruewise.in",
    foundingDate: "2024",
    address: {
        streetAddress: "24th Floor, Tower B, Alphathum Plot No 1 Sec90, Nepz Post Office",
        addressLocality: "Noida",
        addressRegion: "Uttar Pradesh",
        postalCode: "201305",
        addressCountry: "IN",
    },
    sameAs: [
        "https://www.linkedin.com/company/accruewise/",
        "https://x.com/accruewise",
        "https://www.instagram.com/accruewise/",
        "https://www.facebook.com/accruewise/",
    ],
};

export const APP_LINKS = {
    googlePlay:
        "https://play.google.com/store/apps/details?id=com.accruewise.app",
    packageName: "com.accruewise.app",
};

export const SITE_DESCRIPTION =
    "Accruewise is an India-first money app: track every spend automatically, split bills with friends, pay bills and recharges, send money by UPI and IMPS, plan savings goals, spend with a prepaid RuPay card and earn rewards, in English and Hindi.";

export const SITE_KEYWORDS = [
    "Accruewise",
    "fintech app India",
    "savings app",
    "budgeting app",
    "virtual card",
    "marketplace shopping",
    "spend tracker",
    "UPI savings",
    "personal finance India",
    "bill payment app",
    "mobile recharge",
    "IMPS transfer",
    "NCMC top-up",
    "gift vouchers",
    "SMS expense tracker",
].join(", ");
